<template>
  <div class="dashboard-panel p-overview">
    <div>
      <div class="panel-header">
        <h2>Overview</h2>

        <div class="info-wrapper">
          <div>
            <label>Leads</label>
            <h3>{{ overview.leadCount }}</h3>
          </div>
          <div>
            <label>Hot Leads</label>
            <h3>{{ overview.hotLeadCount }}</h3>
          </div>
          <div>
            <label>Loans Funded</label>
            <h3>{{ overview.loansFunded | currency }}</h3>
          </div>
          <div>
            <label>Dropped Deals</label>
            <h3 class="text-red">{{ overview.droppedDealCount }}</h3>
          </div>
        </div>
      </div>
      <div class="panel-content">
        <div class="year-label">{{ yearLabel }}</div>

        <Graph
          v-if="!loading && this.overview.matchesPerMonth.length"
          id="chart-overview"
          :chartData="graphData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Graph from './Graph'

export default {
  name: 'PanelOverview',
  components: {
    Graph,
  },
  props: {
    overview: {
      type: Object,
      default: () => ({
        leadCount: 0,
        hotLeadCount: 0,
        loansFunded: 0,
        droppedDealCount: 0,
        matchesPerMonth: [],
        droppedDealsPerMonth: [],
        start: '',
        end: '',
      }),
    },
  },

  data: () => ({
    loading: true,
    graphData: {},
  }),

  computed: {
    yearLabel () {
      if (!this.overview.start || !this.overview.end) return ''
      const format = 'MMM YYYY'
      const { start, end } = this.overview

      return `Year: ${moment.utc(start).format(format)} - ${moment.utc(end).format(format)}`
    },
  },

  watch: {
    overview: {
      handler () { this.buildGraphData() },
      deep: true,
    },
  },

  mounted () {
    this.buildGraphData()
  },

  methods: {
    buildGraphData () {
      if (!this.overview.start || !this.overview.end) return
      this.loading = true

      const data = this.overview.matchesPerMonth.map(({ time, count }) => ({
        x: moment(time),
        y: count,
      }))

      const other = this.overview.droppedDealsPerMonth.map(({ time, count }) => ({
        x: moment(time),
        y: count,
      }))

      this.graphData = {
        datasets: [
          {
            barPercentage: 0.8,
            minBarLength: 8,
            backgroundColor: '#0096A6',
            data,
          },
          {
            barPercentage: 0.6,
            minBarLength: 8,
            backgroundColor: '#F1563F',
            data: other,
          },
        ],
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-panel {
  & > div {
    width: 100%;
    background-color: transparent !important;
    border: none !important;
  }

  .panel-header {
    padding: 0 35px;
    flex-direction: column;
  }

  .panel-content {
    padding: 30px;
  }

  .info-wrapper {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    padding-left: 30px;

    div {
      text-align: left;
      flex-grow: 0;

      padding-right: 50px;
      @include lg { padding-right: 100px; }

      label {
        color: $textGrey;
        font-family: "Avenir Heavy", sans-serif;
        font-size: 14px;
      }

      h3 {
        color: $accentBlue;
        font-family: "Sansation Bold", sans-serif;
        font-size: 36px;
        line-height: 42px;
      }
    }
  }

  .year-label {
    display: flex;
    justify-content: flex-end;

    font-size: 15px;
  }
}
</style>
